(() => {
  const config = window.JB_CONTACT || {};
  const widget = document.createElement('div');
  widget.className = 'contact-bookmark';
  widget.innerHTML = `
    <button class="contact-bookmark-tab" type="button" aria-expanded="false" aria-controls="contact-bookmark-panel" aria-label="Open Jingbound contact bookmark">
      <span class="bookmark-monogram" aria-hidden="true">J</span>
      <span class="bookmark-tab-label">Contact</span>
      <span class="bookmark-pull" aria-hidden="true">→</span>
    </button>
    <div class="contact-bookmark-panel" id="contact-bookmark-panel" role="region" aria-label="WhatsApp contact options" aria-hidden="true" inert>
      <button class="contact-bookmark-close" type="button" aria-label="Close WhatsApp contacts">×</button>
      <p class="contact-bookmark-kicker">A DEEPER BEIJING</p>
      <h2>Let's Plan Your Beijing Journey</h2>
      <span class="contact-bookmark-rule" aria-hidden="true"></span>
      <div class="contact-bookmark-channel"><svg viewBox="0 0 32 32" aria-hidden="true"><path fill="currentColor" d="M16 2a14 14 0 0 0-12 21.3L2 30l7-1.9A14 14 0 1 0 16 2Zm0 25.4a11.4 11.4 0 0 1-5.8-1.6l-.4-.2-4.1 1.1 1.1-4-.3-.4A11.4 11.4 0 1 1 16 27.4Zm6.3-8.5c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7 0a9.3 9.3 0 0 1-4.6-4c-.3-.5.3-.5.8-1.5.1-.2 0-.4 0-.6l-1-2.3c-.2-.5-.5-.4-.7-.4h-.6c-.2 0-.5.1-.8.4-.3.4-1.1 1.1-1.1 2.7s1.2 3.2 1.4 3.5c.2.2 2.3 3.5 5.6 4.9 2 .8 2.8.9 3.8.7.6-.1 1.9-.8 2.1-1.6.3-.8.3-1.5.2-1.6-.1-.1-.3-.2-.6-.4Z"/></svg><span>WhatsApp</span></div>
      <p class="contact-bookmark-intro">Ask us about <strong class="contact-bookmark-journey">your journey</strong>. Choose a WhatsApp number to start a message:</p>
      <a class="contact-whatsapp-one" target="_blank" rel="noopener noreferrer">+86 138 3803 4331 <span aria-hidden="true">↗</span></a>
      <a class="contact-whatsapp-two" target="_blank" rel="noopener noreferrer">+86 186 0199 8200 <span aria-hidden="true">↗</span></a>
      <p class="contact-bookmark-verse">Real People<br>Local Advice<br>A Deeper Beijing</p>
    </div>`;
  document.body.append(widget);

  const tab = widget.querySelector('.contact-bookmark-tab');
  const panel = widget.querySelector('.contact-bookmark-panel');
  const firstLink = widget.querySelector('.contact-whatsapp-one');
  const secondLink = widget.querySelector('.contact-whatsapp-two');
  tab.querySelector('.bookmark-tab-label').textContent = config.tab || 'Contact';
  widget.querySelector('.contact-bookmark-kicker').textContent = config.kicker || 'A DEEPER BEIJING';
  widget.querySelector('h2').textContent = config.heading || "Let's Plan Your Beijing Journey";
  const intro = widget.querySelector('.contact-bookmark-journey').parentElement;
  intro.firstChild.nodeValue = `${config.intro || 'Ask us about'} `;
  intro.lastChild.nodeValue = `. ${config.outro || 'Choose a WhatsApp number to start a message:'}`;
  widget.querySelector('.contact-bookmark-verse').textContent = config.verse || 'Real People\nLocal Advice\nA Deeper Beijing';
  firstLink.firstChild.nodeValue = `${config.phoneOne || '+86 13838034331'} `;
  secondLink.firstChild.nodeValue = `${config.phoneTwo || '+86 18601998200'} `;
  let positionFrame = 0;
  const positionWithBook = () => {
    positionFrame = 0;
    const spreads = [...document.querySelectorAll('.spread-panel')];
    const visibleSpread = spreads.sort((a, b) => parseFloat(getComputedStyle(b).opacity) - parseFloat(getComputedStyle(a).opacity))[0];
    const cover = document.querySelector('.cover-media');
    const useCover = cover && (!visibleSpread || parseFloat(getComputedStyle(document.querySelector('.home-panel')).opacity) >= parseFloat(getComputedStyle(visibleSpread).opacity));
    const compact = matchMedia('(max-width: 900px)').matches;
    let book = useCover ? cover : visibleSpread?.querySelector('.open-book') || document.querySelector('.journey-book');
    if (compact) {
      const candidates = [cover, ...document.querySelectorAll('.spread-panel .open-book, .journey-book')].filter(Boolean);
      book = candidates.filter(candidate => {
        const bounds = candidate.getBoundingClientRect();
        return bounds.height > 0 && bounds.bottom > 160 && bounds.top < innerHeight - 100;
      }).sort((a, b) => Math.abs(a.getBoundingClientRect().top - 80) - Math.abs(b.getBoundingClientRect().top - 80))[0];
    }
    widget.hidden = compact && !book && !widget.classList.contains('is-open');
    if (!book) return;
    const rect = book.getBoundingClientRect();
    const tabWidth = compact ? 36 : 42;
    const x = Math.max(0, Math.min(innerWidth - tabWidth - 4, rect.right - rect.width * (book === cover ? .10 : .035) - 12));
    const y = compact ? Math.max(16, Math.min(rect.bottom - 180, rect.top + 40)) : rect.top + rect.height * (useCover ? .07 : .09);
    widget.style.setProperty('--bookmark-left', `${Math.round(x)}px`);
    widget.style.setProperty('--bookmark-top', `${Math.round(y)}px`);
    widget.style.setProperty('--bookmark-panel-offset', `${compact ? Math.max(12 - y, Math.min(0, innerHeight - 110 - Math.min(panel.scrollHeight, innerHeight - 130) - y)) : 2}px`);
    widget.classList.toggle('on-cover', book === cover);
  };
  const schedulePosition = () => { if (!positionFrame) positionFrame = requestAnimationFrame(positionWithBook); };
  if (document.querySelector('.cover-media')) new MutationObserver(schedulePosition).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
  addEventListener('resize', schedulePosition);
  addEventListener('scroll', schedulePosition, { passive: true });
  schedulePosition();
  const durations = { '3-hours': '3 Hours', '1-day': '1 Day', '2-days': '2 Days', '3-days': '3 Days', '5-days': '5 Days', '7-days': '7 Days' };
  const duration = durations[new URLSearchParams(location.search).get('duration')] || '3 Hours';

  const subject = () => {
    if (document.body.classList.contains('listing-page')) return `${document.getElementById('listing-title').textContent.trim()} (${duration})`;
    if (document.body.classList.contains('series-page')) return `${document.getElementById('series-title').textContent.trim()} (${duration})`;
    if (document.body.classList.contains('journey-page')) return `${duration} in Beijing`;
    const chapter = document.querySelector('.chapter-rail .chapter-link.active strong')?.textContent.trim();
    return chapter && chapter !== 'Home' ? chapter : 'private Beijing journeys';
  };

  const updateLinks = () => {
    const topic = subject();
    widget.querySelector('.contact-bookmark-journey').textContent = topic;
    const message = `${config.messagePrefix || "Hello Jingbound, I'm interested in"} ${topic}. ${config.messageSuffix || 'Could you help me plan a private Beijing journey?'}`;
    firstLink.href = `https://wa.me/${(config.phoneOne || '+86 13838034331').replace(/\D/g, '')}?text=${encodeURIComponent(message)}`;
    secondLink.href = `https://wa.me/${(config.phoneTwo || '+86 18601998200').replace(/\D/g, '')}?text=${encodeURIComponent(message)}`;
  };

  const setOpen = open => {
    if (open) updateLinks();
    panel.inert = !open;
    panel.setAttribute('aria-hidden', String(!open));
    widget.classList.toggle('is-open', open);
    schedulePosition();
    tab.setAttribute('aria-expanded', String(open));
    if (open) firstLink.focus({ preventScroll: true });
    else tab.focus({ preventScroll: true });
  };

  tab.addEventListener('click', () => setOpen(!widget.classList.contains('is-open')));
  widget.querySelector('.contact-bookmark-close').addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && widget.classList.contains('is-open')) setOpen(false); });
  document.addEventListener('pointerdown', event => {
    if (widget.classList.contains('is-open') && !widget.contains(event.target)) setOpen(false);
  });
  if (document.querySelector('.story')) {
    new MutationObserver(() => { if (widget.classList.contains('is-open')) updateLinks(); }).observe(document.querySelector('.chapter-rail nav'), { attributes: true, attributeFilter: ['class'], subtree: true });
  }
  updateLinks();
})();
